import { SCALAR_TYPES } from "./types.mjs";
export function getObjectPaths(obj, includeArrayIndicies = false, parentKey = []) {
    if (!obj)
        return [];
    let paths = [];
    let objKeys = Object.keys(obj);
    for (let i = 0; i < objKeys.length; i++) {
        let k = objKeys[i];
        let v = obj[k];
        let currentPath = [...parentKey, k];
        if (v === null || SCALAR_TYPES.includes(typeof v)) {
            paths.push(currentPath);
        }
        else if (Array.isArray(v)) {
            if (!includeArrayIndicies)
                paths.push(currentPath);
            else {
                paths = paths.concat(v.map((_, idx) => {
                    return [...currentPath, idx.toString()];
                }));
            }
        }
        else if (typeof v === 'object') {
            let subPaths = getObjectPaths(v, includeArrayIndicies, currentPath);
            paths = paths.concat(subPaths);
        }
    }
    return paths;
}
